const updateBdnNumber = (obj) => {
  if (!obj.bdn_no_suffix) return;

  if (obj.suffix === null) {
    obj.bdn_number = `${obj.bdn_no_suffix}`;
  } else {
    obj.bdn_number = `${obj.bdn_no_suffix}_${obj.suffix}`;
  }
};

export const parseBdnPlainObjects = (arr) => {
  resetRows(arr);
  addSuffixesToDuplicates(buildRef(arr));
};

const resetRows = (arr) => {
  arr.forEach((tankStock) => {
    if(!tankStock) return;
    tankStock.suffix = null;
    updateBdnNumber(tankStock);
  });
};

const buildRef = (arr) => {
  return arr.reduce((prev, curr) => {
    if (!curr) return prev;
    if (curr.bdn_number === '') return prev;

    if (prev.hasOwnProperty(curr.bdn_number)) {
      prev[curr.bdn_number] = [...prev[curr.bdn_number], curr];
    } else {
      prev[curr.bdn_number] = [curr];
    }

    return prev;
  }, {});
};

const addSuffixesToDuplicates = (bdnRef) => {
  const bdnKeys = Object.keys(bdnRef);
  const duplicateKeys = bdnKeys.filter((a) => bdnRef[a].length > 1);

  duplicateKeys.forEach((key) => {
    bdnRef[key].forEach((tankStock, i) => {
      if(!tankStock) return;
      tankStock.suffix = i + 1;
      updateBdnNumber(tankStock);
    });
  });
};
